import auth from './auth';
import user from './user';
import mqtt from './mqtt';
import system from './system';
import presentation from './presentation'
import station from './station'
import device from './device'
import camera from './camera'
import group from './group'
import account from './account'
import hub from './hub'
import chart from './chart'

export default {
  auth,
  user,
  system,
  mqtt,
  presentation,
  station,
  device,
  camera,
  group,
  account,
  hub,
  chart
};



// WEBPACK FOOTER //
// ./src/reducers/index.js